function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1d1d1d",
  d: "M24399.287-5483.071a.341.341 0 0 1-.271-.2.325.325 0 0 1 .068-.334l9.322-10.339 4.459-4.939a.325.325 0 0 1 .467-.033l1.531 1.367a.4.4 0 0 1 .133.235.355.355 0 0 1-.1.233l-4.26 4.7 1.262 1.167a.3.3 0 0 1 .1.233.35.35 0 0 1-.1.233l-3.926 4.336a10.128 10.128 0 0 1-3.662 2.6h4.529a.314.314 0 0 1 .33.334.315.315 0 0 1-.33.334h-6.828a9.286 9.286 0 0 1-1.662.133c-.367.011-.732-.027-1.062-.06zm12.914-.065a.316.316 0 0 1-.334-.334.315.315 0 0 1 .334-.334h.828a.335.335 0 0 1 .336.334.317.317 0 0 1-.336.334zm-1.967 0a.315.315 0 0 1-.332-.334.315.315 0 0 1 .332-.334h.834a.317.317 0 0 1 .334.334.318.318 0 0 1-.334.334z",
  transform: "translate(-24394.996 5503.001)"
});

function SvgSmallIconProcedure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallIconProcedure);
export default __webpack_public_path__ + "static/media/small-icon-procedure.d3f08f18.svg";
export { ForwardRef as ReactComponent };